import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';

import { UploadSkuStateContext } from '.';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		skuStatus: null,
		skuPreviousStatus: null,
		isSkuStateFetching: false,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				skuStatus: response.data,
			});
		}
	}

	handleRefetch = forceChildrenUpdate => {
		this.setState({ isSkuStateFetching: true });
		if (forceChildrenUpdate) {
			this.setState({
				skuStatus: null,
				skuPreviousStatus: this.state.skuStatus,
			});
		}
		this.props.response.refetch();
		this.setState({ isSkuStateFetching: false });
	};

	render() {
		return (
			<UploadSkuStateContext.Provider
				value={{
					...this.state,
					refetchSkuState: this.handleRefetch,
				}}
			>
				{this.state.skuStatus || this.props.response.success
					? this.props.children
					: null}
			</UploadSkuStateContext.Provider>
		);
	}
}

export const UploadSkuStateContextProvider = withRouter(
	withData('/sku/get-sku-state')(Provider)
);
